// @ts-check
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getUserAction } from '../redux/actions/user-actions';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import { UserStatusComponent } from '../components/user-status-component';

import { LoadingComponent } from '../../../clients/presentation/components/loading-component';
import { UserImageComponent } from '../components/user-image-component';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  heading: {
    margin: theme.spacing(2)
  },
  sectionHeading: {
    margin: theme.spacing(3)
  },
  driverHeader: {
    textAlign: 'center'
  },
  driverLogo: {
    height: '10rem',
    width: '10rem',
    objectFit: 'contain'
  },
  large: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  }
}));

function CenteredGrid({ user }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <UserImageComponent user={user} />
      </Grid>

      <Grid item xs={12} md={8}>
        <UserStatusComponent user={user} />
      </Grid>
    </Grid>
  );
}

export default function UserPage() {
  // @ts-ignore
  const { id } = useParams();
  const classes = useStyles();

  const { user, loading } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserAction(id));
  }, [dispatch, id]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && user && (
            <>
              <BackNavigationComponent
                page="User"
                uri="/users"
                path={[
                  {
                    page: 'Home',
                    uri: '/'
                  },
                  {
                    page: 'Users',
                    uri: '/users'
                  }
                ]}
              />
              <CenteredGrid user={user} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
